import './less/langChanger.less';

const langChanger = (function(){
    let changer = document.getElementById('langChanger');
    
    const toggleChanger = () => {
        changer.classList.toggle('active');
    };
    
    if(changer) {
        changer.addEventListener('click', toggleChanger);
    }
    
    
})();



export { langChanger };


// WEBPACK FOOTER //
// ./components/langChanger/langChanger.js